/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Choose_FreeInputs */

const en_pricing_choose_free = /** @type {(inputs: Pricing_Choose_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose free plan`)
};

const es_pricing_choose_free = /** @type {(inputs: Pricing_Choose_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir plan gratis`)
};

/**
* | output |
* | --- |
* | "Choose free plan" |
*
* @param {Pricing_Choose_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_choose_free = /** @type {((inputs?: Pricing_Choose_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Choose_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_choose_free(inputs)
	return en_pricing_choose_free(inputs)
});